"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var cfo_chart_chart_1 = require("./cfo-chart.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var chart_table_logic_1 = require("../../../components/chart-table/chart-table.logic");
var CfoChartComponent = /** @class */ (function (_super) {
    __extends(CfoChartComponent, _super);
    function CfoChartComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'CfoChart') || this;
        _this.changeLabelLength = function (change) {
            if (change === void 0) { change = 0; }
            var ctrl = _this;
            if (!ctrl.settings.charsInLabel) {
                ctrl.settings.charsInLabel = 0;
            }
            ctrl.settings.charsInLabel = parseInt(ctrl.settings.charsInLabel);
            ctrl.settings.charsInLabel += change;
            ctrl.drawChart();
        };
        var ctrl = _this;
        $scope.$on('command:CFO_CHART', function (event, args) { return ctrl.initComponent(event, args); });
        return _this;
    }
    CfoChartComponent.prototype.getChartOptions = function (graph, options) {
        this.graph = graph;
        this.options = options;
        this.groupBySelectChart = options.settings.groupByDisplay;
        var mainRows = graph.mainRows, siblingRows = graph.siblingRows;
        this.showRedMarkerNote = (mainRows && mainRows.some(function (r) { return r.ax < 0; })) ||
            (siblingRows && siblingRows.some(function (r) { return r.ax < 0; }));
        if (this.groupBySelectChart && graph['mainDrillDown'].length > 0) {
            this.makeDrillDownTableData();
            this.showCurveTable = true;
            return cfo_chart_chart_1.getGroupByChartOptions(this.graph, this.options);
        }
        else {
            this.showCurveTable = false;
            return cfo_chart_chart_1.getChartOptions(this.graph, this.options);
        }
    };
    CfoChartComponent.prototype.makeDrillDownTableData = function () {
        var _this = this;
        this.mainDrillDownTableData = [];
        this.selectedGraph.mainDrillDown.forEach(function (item) {
            var tmp = angular.copy(_this.tableData);
            tmp['inputData']['mainRows'] = item['data'];
            tmp['inputData']['siblingRows'] = [];
            _this.mainDrillDownTableData.push(tmp);
        });
        if (this.selectedGraph.siblingRows.length > 0) {
            var tmp = angular.copy(this.tableData);
            tmp['inputData']['mainRows'] = [];
            this.mainDrillDownTableData.push(tmp);
        }
        this.formattedDataList = [];
        this.mainDrillDownTableData.forEach(function (table) {
            _this.formattedDataList.push(chart_table_logic_1.ChartTable.generateTable(table));
        });
    };
    CfoChartComponent.prototype.exportCsv = function (csvFormat) {
        if (csvFormat === void 0) { csvFormat = ''; }
        if (this.groupBySelectChart && this.graph['mainDrillDown'].length > 0) {
            var filename = this.filename();
            this.exportNow(filename, csvFormat, false);
        }
        else {
            _super.prototype.exportCsv.call(this, csvFormat);
        }
    };
    CfoChartComponent.prototype.exportNow = function (filename, csvFormat, skipSave) {
        var csv = '';
        this.formattedDataList.forEach(function (table) {
            csv += chart_table_logic_1.ChartTable.generateCsv(table, csvFormat);
            csv += '\n\n';
        });
        if (!skipSave) {
            var blob = new Blob([csv], { type: "text/plain;charset=utf-8" });
            saveAs(blob, filename);
        }
        return csv;
    };
    CfoChartComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./cfo-chart.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], CfoChartComponent);
    return CfoChartComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.CfoChartComponent = CfoChartComponent;
angular.module('smartorg.r6.acts.cfoChart', []).component('cfoChart', CfoChartComponent);
module.exports = 'smartorg.r6.acts.cfoChart';
//# sourceMappingURL=cfo-chart.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/cfo-chart/cfo-chart.component.js